module.exports = __webpack_public_path__ + "media/components/errors/not-found-c47fa9f0b094b69221469167a01209d6.jpg";